(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tst-3d-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const section = document.currentScript?.closest('.shopify-section')?.querySelector('.tst-3d-hero');
  if (!section || section.dataset.enableMesh !== 'true') return;

  const canvas = section.querySelector('.tst-3d-hero__canvas');
  if (!canvas) return;

  const ctx = canvas.getContext('2d', { alpha: true });
  if (!ctx) return;

  let rafId = null;
  let width = 0;
  let height = 0;
  let dpr = 1;
  let points = [];
  let mouseX = 0;
  let mouseY = 0;
  let targetMouseX = 0;
  let targetMouseY = 0;

  const particleCount = Math.max(8, Number(section.dataset.particleCount || 26));
  const linkDistance = Math.max(40, Number(section.dataset.linkDistance || 220));
  const speed = Math.max(0, Number(section.dataset.speed || 0.16));
  const mouseStrength = Math.max(0, Number(section.dataset.mouseStrength || 0.18));
  const lineOpacity = Math.max(0, Math.min(1, Number(section.dataset.lineOpacity || 0.28)));
  const dotOpacity = Math.max(0, Math.min(1, Number(section.dataset.dotOpacity || 0.55)));
  const dotSize = Math.max(0.5, Number(section.dataset.dotSize || 1.4));
  const meshTop = Math.max(0, Math.min(100, Number(section.dataset.meshTop || 38))) / 100;
  const meshBottom = Math.max(0, Math.min(100, Number(section.dataset.meshBottom || 100))) / 100;
  const enableMouse = section.dataset.enableMouse === 'true';
  const enableFloat = section.dataset.enableFloat === 'true';

  const randomRange = (min, max) => min + Math.random() * (max - min);

  const makePoint = () => ({
    x: Math.random() * width,
    y: randomRange(height * meshTop, height * meshBottom),
    z: randomRange(0.65, 1.35),
    vx: randomRange(-0.18, 0.18) * speed,
    vy: randomRange(-0.12, 0.12) * speed,
    phase: Math.random() * Math.PI * 2,
    pulse: randomRange(0.4, 1)
  });

  const buildPoints = () => {
    points = Array.from({ length: particleCount }, makePoint);
  };

  const resize = () => {
    const rect = section.getBoundingClientRect();
    width = Math.max(1, rect.width);
    height = Math.max(1, rect.height);
    dpr = Math.min(window.devicePixelRatio || 1, 2);

    canvas.width = Math.round(width * dpr);
    canvas.height = Math.round(height * dpr);
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    buildPoints();
  };

  const onPointerMove = (event) => {
    if (!enableMouse) return;
    const rect = section.getBoundingClientRect();
    targetMouseX = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
    targetMouseY = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
  };

  const onPointerLeave = () => {
    targetMouseX = 0;
    targetMouseY = 0;
  };

  const updatePoint = (point, time) => {
    if (enableFloat) {
      point.x += point.vx;
      point.y += point.vy;
    }

    const top = height * meshTop;
    const bottom = height * meshBottom;

    if (point.x < -30) point.x = width + 30;
    if (point.x > width + 30) point.x = -30;
    if (point.y < top - 30) point.y = bottom + 30;
    if (point.y > bottom + 30) point.y = top - 30;

    point.displayX = point.x + mouseX * 22 * mouseStrength * point.z;
    point.displayY = point.y + mouseY * 16 * mouseStrength * point.z + Math.sin(time * 0.00045 + point.phase) * 4 * point.pulse;
  };

  const draw = (time) => {
    ctx.clearRect(0, 0, width, height);

    mouseX += (targetMouseX - mouseX) * 0.035;
    mouseY += (targetMouseY - mouseY) * 0.035;

    for (const point of points) updatePoint(point, time);

    ctx.lineWidth = 0.75;
    ctx.strokeStyle = `rgba(255,255,255,${lineOpacity})`;

    for (let i = 0; i < points.length; i++) {
      const a = points[i];
      for (let j = i + 1; j < points.length; j++) {
        const b = points[j];
        const dx = a.displayX - b.displayX;
        const dy = a.displayY - b.displayY;
        const dist = Math.sqrt(dx * dx + dy * dy);

        if (dist < linkDistance) {
          const alpha = (1 - dist / linkDistance) * lineOpacity;
          ctx.strokeStyle = `rgba(255,255,255,${alpha})`;
          ctx.beginPath();
          ctx.moveTo(a.displayX, a.displayY);
          ctx.lineTo(b.displayX, b.displayY);
          ctx.stroke();
        }
      }
    }

    for (const point of points) {
      const radius = dotSize * point.z;
      ctx.fillStyle = `rgba(255,255,255,${dotOpacity * Math.min(1, point.z)})`;
      ctx.beginPath();
      ctx.arc(point.displayX, point.displayY, radius, 0, Math.PI * 2);
      ctx.fill();
    }

    rafId = requestAnimationFrame(draw);
  };

  const observer = new ResizeObserver(resize);
  observer.observe(section);

  section.addEventListener('pointermove', onPointerMove, { passive: true });
  section.addEventListener('pointerleave', onPointerLeave, { passive: true });

  resize();
  rafId = requestAnimationFrame(draw);

  const cleanup = () => {
    if (rafId) cancelAnimationFrame(rafId);
    observer.disconnect();
    section.removeEventListener('pointermove', onPointerMove);
    section.removeEventListener('pointerleave', onPointerLeave);
  };

  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target?.contains(section)) cleanup();
  }, { once: true });
})();

  } catch(e) { console.error(e); }
})();
})();
